module.exports = __webpack_public_path__ + "img/8.7ebd1c1d.jpg";